
import { useEffect } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import CompanyStory from './components/CompanyStory';
import TeamSection from './components/TeamSection';
import ValuesSection from './components/ValuesSection';
import AchievementsSection from './components/AchievementsSection';

const AboutPage = () => {
  useEffect(() => {
    // Update page title and meta description
    document.title = 'About OED Glamping Retreat Developments - Our Story & Mission';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Learn about OED Glamping Retreat Developments mission to create sustainable luxury outdoor experiences. Founded by Jerry Lee Jr, we combine eco-tourism with profitable investment opportunities.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'about OED, glamping company, Jerry Lee Jr, sustainable tourism, eco-luxury, company story');
    }

    // Update social media images
    const ogImage = document.querySelector('meta[property="og:image"]');
    if (ogImage) {
      ogImage.setAttribute('content', 'https://public.readdy.ai/ai/img_res/395196d2a4d4c516a85b78b0628b13fd.jpg');
    }

    const twitterImage = document.querySelector('meta[property="twitter:image"]');
    if (twitterImage) {
      twitterImage.setAttribute('content', 'https://readdy.ai/api/search-image?query=Professional%20team%20of%20glamping%20industry%20experts%20in%20modern%20office%20setting%20with%20sustainable%20eco-friendly%20design%20elements%2C%20Jerry%20Lee%20Jr%20founder%20portrait%2C%20Alabama%20business%20leadership%20in%20outdoor%20hospitality%20industry%2C%20corporate%20photography%20with%20natural%20lighting%20and%20professional%20atmosphere&width=1200&height=630&seq=about-twitter&orientation=landscape');
    }

    // Add Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "name": "About OED Glamping Retreat Developments",
      "description": "Learn about OED Glamping Retreat Developments mission to create sustainable luxury outdoor experiences. Founded by Jerry Lee Jr, we combine eco-tourism with profitable investment opportunities.",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/about`,
      "mainEntity": {
        "@type": "Organization",
        "name": "OED Glamping Retreat Developments",
        "founder": {
          "@type": "Person",
          "name": "Jerry Lee Jr"
        },
        "foundingDate": "2020",
        "description": "Sustainable luxury glamping retreat development company"
      }
    });
    document.head.appendChild(script);

    return () => {
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <main>
        <AboutHero />
        <CompanyStory />
        <ValuesSection />
        <TeamSection />
        <AchievementsSection />
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;
